/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import moment from 'moment'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import FromToPicker from '../BaseComponent/FromToPicker'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'

class ReportPaid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      lengthProducts: 0,
      listPaid: [],
      printInfo: [],
      Drivers: [],
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',
      buttonClicked: false,
      driverId: ''
    }
  }

  handleDateChangeFrom = (date) => {
    this.setState({selectedDateFrom: date, selectedDateTo: date})
    // this.toDateInput.focus();
  }

  handleDateChangeTo = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error === null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            Drivers: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      listPaid: data
    })
  }

  changeDropDown(data) {
    this.setState({
      listPaid: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  convertState = (x) => {
    if (x === -100) {
      x = 'کنسل'
      return x
    } else if (x === -75) {
      x = 'مرجوعی'
      return x
    } else if (x === -50) {
      x = 'بازگشتی'
      return x
    } else if (x === -25) {
      x = 'تخصیص مجدد'
      return x
    } else if (x === -1) {
      x = 'تخصیص داده نشده'
      return x
    } else if (x === 1) {
      x = 'فعال'
      return x
    } else if (x === 5) {
      x = 'اول فعال'
      return x
    } else if (x === 10) {
      x = 'شروع شده'
      return x
    } else if (x === 18) {
      x = 'تسویه نشده'
      return x
    } else if (x === 20) {
      x = 'تسویه شده'
      return x
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    var deliveryPackId = this.convertDigit(document.getElementById('deliveryPackId').value.trim())
    var invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    var invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    var dispatchDateMin = this.state.fromDate
    var dispatchDateMax = this.state.toDate
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    if (
      invoiceNum === '' &&
      payOnDelivery === '' &&
      paid === '' &&
      canceled === '' &&
      confirmed === '' &&
      deliveryPackId === '' &&
      invoiceId === '' &&
      driverId === '' &&
      dispatchDateMax === '' &&
      dispatchDateMin === ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState({
        toPrintDate: this.state.fromDate === '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: this.state.toDate === '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true
      })
      sessionStorage.setItem(
        'params',
        `invoiceNum=${invoiceNum}&paid=${paid}&confirmed=${confirmed}&canceled=${canceled}&payOnDelivery=${payOnDelivery}&deliveryPackId=${deliveryPackId}&invoiceId=${invoiceId}&driverId=${driverId}&dispatchDateMin=${
          dispatchDateMin === '' ? '' : dispatchDateMin
        }&dispatchDateMax=${dispatchDateMax === '' ? '' : dispatchDateMax}&sortBy=planDate_Desc`
      )

      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER
          }?export=false&pageSize=10&pageNumber=1&sortBy=planDate_Desc&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error === null) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              listPaid: response.data.object.result,
              lengthProducts: response.data.object.countAll,
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })
            // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            // .dispatch.dispatchDate

            if (excelReport[i].dispatch['dispatchDate'] === null) {
              excelReport[i].dispatch['dispatchDate'] = ''
            } else {
              excelReport[i].dispatch['dispatchDate'] = jMoment(excelReport[i].dispatch['dispatchDate']).format(
                'jYY/jMM/jDD HH:mm'
              )
            }
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')

            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            excelReport[i]['lastState'] = this.convertState(excelReport[i].dispatch['lastState'])

            if (excelReport[i]['car'] === null) {
              excelReport[i]['carInfo'] = ''
            } else {
              excelReport[i]['carInfo'] =
                excelReport[i].car['name'] +
                ' ' +
                'ایران ' +
                excelReport[i].car['plateNumber'] +
                '-' +
                excelReport[i].car['plateText'] +
                ' کد ' +
                excelReport[i].car['code']
            }

            if (excelReport[i]['driver'] === null) {
              excelReport[i]['driver'] = ''
            } else {
              excelReport[i]['driver'] = excelReport[i].driver['name']
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'تایید شده'
            } else {
              excelReport[i].invoice['confirmed'] = 'تایید نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {loading} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let excelColumns = [
      {title: 'شناسه', value: 'deliveryPackId'},
      {title: 'شناسه فاکتور', value: 'invoiceId'},
      {title: 'حالت', value: 'state'},
      {title: 'رساننده', value: 'capacity'},
      {title: 'خودرو', value: 'plateNumber'},
      {title: 'زمان تحویل', value: 'plateText'}
    ]
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'شناسه پارت تحویل',
      'شناسه فاکتور',
      'شماره فاکتور',
      'وضعیت پرداخت',
      'پرداخت در محل',
      'حالت',
      'رساننده',
      'خودرو',
      'تاریخ تحویل',
      'بازه تحویل',
      'زمان تحویل'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش پرداختی رساننده ها"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={12}
              rightColSpan={7}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={'تاریخ از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{list.dispatch.deliveryPackId}</td>
                  <td>{list.invoice.invoiceId}</td>
                  <td>{list.invoice.invoiceNum}</td>
                  <td>{list.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                  <td>{list.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                  <td>{this.convertState(list.dispatch.lastState)}</td>
                  <td>{list.driver === null ? '-' : list.driver.name}</td>
                  <td>
                    {list.car === null
                      ? '-'
                      : list.car.name +
                        ' ' +
                        'ایران ' +
                        list.car.plateNumber +
                        '-' +
                        list.car.plateText +
                        ' کد ' +
                        list.car.code}
                  </td>
                  <td>{list.planDate === null ? '-' : jMoment(list.planDate).format('jYYYY/jM/jD')}</td>
                  <td>{list.planTimeFrom + ' - ' + list.planTimeTo}</td>
                  <td>
                    {list.dispatch.dispatchDate === null
                      ? '-'
                      : jMoment(list.dispatch.dispatchDate).format('jYYYY/jM/jD HH:mm')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش پرداختی ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'deliveryPackId'}
                field={'dispatch.deliveryPackId'}
                title={'شناسه پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmed'}
                field={'invoice.confirmed'}
                title={'وضعیت تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'canceled'}
                field={'invoice.canceled'}
                title={'وضعیت کنسل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'lastState'}
                field={'lastState'}
                title={'حالت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'carInfo'}
                field={'carInfo'}
                title={'خودرو'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'dispatchDate'}
                field={'dispatch.dispatchDate'}
                title={'زمان تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارش پرداختی ها</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ تحویل از"
                  toLabel=" تاریخ تحویل تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>شناسه پارت تحویل</label>
                  <input className="form-control" id="deliveryPackId" type="text" />
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور</label>
                  <input className="form-control" id="invoiceId" type="text" />
                </div>
                <div className="formComponent">
                  <label>شماره فاکتور</label>
                  <input className="form-control" id="invoiceNum" type="text" />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>شناسه پارت تحویل</td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>
                    <td>وضعیت پرداخت</td>
                    <td>پرداخت در محل</td>
                    <td>حالت</td>
                    <td>رساننده</td>
                    <td>خودرو</td>
                    <td>تاریخ تحویل</td>
                    <td>بازه تحویل</td>
                    <td>زمان تحویل</td>
                    <td>جزییات</td>
                  </tr>
                  {this.state.listPaid.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.dispatch.deliveryPackId}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?invoiceId=${list.invoice.invoiceId}&userCode=${''}`
                          }}
                          target={'_blank'}
                        >
                          {list.invoice.invoiceId}
                        </Link>
                      </td>
                      <td>{list.invoice.invoiceNum}</td>
                      <td>{list.invoice.paid ? 'پرداخت شده' : 'پرداخت نشده'}</td>
                      <td>{list.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                      <td>{this.convertState(list.dispatch.lastState)}</td>
                      <td>{list.driver === null ? '-' : list.driver.name}</td>
                      <td>
                        {list.car === null
                          ? '-'
                          : list.car.name +
                            ' ' +
                            'ایران ' +
                            list.car.plateNumber +
                            '-' +
                            list.car.plateText +
                            ' کد ' +
                            list.car.code}
                      </td>
                      <td>{list.planDate === null ? '-' : jMoment(list.planDate).format('jYYYY/jM/jD')}</td>
                      <td>{list.planTimeFrom + ' - ' + list.planTimeTo}</td>
                      <td>
                        {list.dispatch.dispatchDate === null
                          ? '-'
                          : jMoment(list.dispatch.dispatchDate).format('jYYYY/jM/jD HH:mm')}
                      </td>

                      <td>
                        <Link
                          target="_blank"
                          to={`/detailsPaid/${list.dispatch.detailId}/${list.dispatch.invoiceId}/${
                            list.driver === null ? '-' : list.driver.name
                          }`}
                        >
                          <img src={require('../../image/details.svg')} alt="" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_MASTER}
                  urlParams={urlParams + '&sortBy=planDate_Desc'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ReportPaid
